export const auth = (userId: string | null) => {
	window.myTSAccountProtection.setAuthenticatedUser(userId ?? '')
}
